import { render, staticRenderFns } from "./PDisplayContainerStatus.vue?vue&type=template&id=6bb8e73e"
import script from "./PDisplayContainerStatus.vue?vue&type=script&lang=js"
export * from "./PDisplayContainerStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports